
import ExternalLinkManagementForm from "../../modules/external-link-management/forms/ExternalLinkManagementForm.vue";
import RouterViewRender from "../../utils/routes/router-view-render";

const ExternalLinkManagementRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "gestao-links-externos",
      component: ExternalLinkManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default ExternalLinkManagementRoutes;
